export default {
  system: {
    title: "Application",
    docs: "https://docs.recurly.com/recurly-engage/docs/setup-your-app",
  },
  user_id: { title: "User ID Matching" },
  app_messages: "App Messages",
  segment_traits: "User Traits",
  usage_tracking: "Usage Tracking",
  tags: { title: "Tags", action: "Create new tag" },
  triggers: {
    title: "Triggers",
    docs: "https://docs.recurly.com/recurly-engage/docs/triggers",
  },
  connectors: "Integrations",
  zones: {
    title: "Zones",
    docs: "https://docs.recurly.com/recurly-engage/docs/zones",
    action: "New Zone",
  },
  custom_devices: { title: "Custom Devices", action: "New custom device" },
  users: { title: "Users", docs: "https://docs.recurly.com/recurly-engage/docs/pulse-users" },
  custom_web_snippet: {
    title: "Custom JS Snippet",
    docs: "https://docs.recurly.com/recurly-engage/docs/custom-js-snippet",
  },
  css_styles: "Global CSS Styles",
  download_csv: "Download Data",
  admin: "Admin",
  data_sources: {
    title: "Data Sources",
    action: "New data source",
    docs: "https://docs.recurly.com/recurly-engage/docs/data-sources",
  },
  sales_admin: "Sales Admin",
  aws_marketplace: "Aws Marketplace Settings",
};
